import { FormState, PersonalDetailsFields } from '@constants/commonApp/types';

export interface SchoolDetailsProps<T> {
  id: string;
  onExpand: () => void;
  onSaveAndContinue: () => Promise<void>;
  isExtended: boolean;
  isSaved: boolean;
}

export enum CounselorSection {
  Certifications = 'Certifications',
}

export enum TeacherSection {
  SchoolDetailsTeacher = 'SchoolDetailsTeacher',
}

export enum PersonalDetailsSection {
  PersonalDetails = 'PersonalDetails',
}

export type Section = CounselorSection | TeacherSection | PersonalDetailsSection;

export const CertificationsConstants: { [key: string]: string } = {
  transcript: 'Transcript',
  communication: 'Agreed_Com',
} as const;

export interface CertificationsFields {
  transcript?: typeof CertificationsConstants.transcript | undefined;
  communication?: typeof CertificationsConstants.communication | undefined;
}

export interface ProfileState {
  [PersonalDetailsSection.PersonalDetails]: FormState<PersonalDetailsFields> | null;
  [CounselorSection.Certifications]: FormState<CertificationsFields> | null;
  [TeacherSection.SchoolDetailsTeacher]: FormState<SchoolDetailsTeacherFields> | null;
}

export const counselorSections = [CounselorSection.Certifications];

export const teacherSections = [TeacherSection.SchoolDetailsTeacher];

export const allSections = [PersonalDetailsSection.PersonalDetails, ...counselorSections, ...teacherSections];

export interface SchoolDetailsTeacherFields {
  academicRating: string | undefined | null;
}
